export const adminOpportunityRules = [
	{
        id:"1",
        text:"Ensure all details are clear and concise, including eligibility criteria, deadlines, and application procedures."
    },
	{
        id:"2",
        text:"Review for accuracy and relevance, ensuring the opportunity aligns with the platform's objectives and audience."
    },
	{
        id:"3",
        text:"Confirm that all necessary documents and resources are accessible to applicants, promoting inclusivity and equal opportunity."
    },
	{
        id:"4",
        text:"Consider adding engaging visuals or compelling descriptions to increase the opportunity's appeal and reach."
    },
];
